// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Annotation Portal React components
import MDBox from "components/MDBox";

// Annotation Portal React example components
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication pages components
import Footer from "layouts/authentication/components/Footer";

function BasicLayout({ image, children }) {
  return (
    <PageLayout>
      <MDBox
        position="absolute"
        width="100%"
        minHeight="100vh"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            image
              ? `${linearGradient(
                  rgba(gradients.dark.main, 0.6),
                  rgba(gradients.dark.state, 0.6)
                )}, url(${image})`
              : "radial-gradient(circle at 20% 20%, rgba(147, 197, 253, 0.55) 0%, transparent 45%), radial-gradient(circle at 80% 30%, rgba(196, 181, 253, 0.5) 0%, transparent 50%), radial-gradient(circle at 50% 90%, rgba(125, 211, 252, 0.45) 0%, transparent 55%), linear-gradient(135deg, #f8fafc 0%, #eef2ff 50%, #f5f3ff 100%)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          "&::after": image
            ? undefined
            : {
                content: '""',
                position: "absolute",
                inset: 0,
                backgroundImage:
                  "linear-gradient(rgba(15,23,42,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(15,23,42,0.05) 1px, transparent 1px)",
                backgroundSize: "44px 44px",
                pointerEvents: "none",
                opacity: 0.7,
              },
        }}
      />
      <MDBox px={1} width="100%" height="100vh" mx="auto">
        <Grid container spacing={1} justifyContent="center" alignItems="center" height="100%">
          <Grid item xs={11} sm={9} md={5} lg={4} xl={3}>
            {children}
          </Grid>
        </Grid>
      </MDBox>
      <Footer light />
    </PageLayout>
  );
}

// Typechecking props for the BasicLayout
BasicLayout.propTypes = {
  image: PropTypes.string,
  children: PropTypes.node.isRequired,
};

BasicLayout.defaultProps = {
  image: "",
};

export default BasicLayout;
